import { useQuery } from "@tanstack/react-query";
import { getPackage } from "src/api/package";
import { QUERY_KEYS } from "../constants/queryKeys";
const useGetPackageQuery = (packageId)=>{
    return useQuery({
        queryKey: [
            QUERY_KEYS.PACKAGE,
            packageId
        ],
        queryFn: ()=>getPackage(packageId),
        enabled: !!packageId
    });
};
export default useGetPackageQuery;
